export default "__VITE_ASSET__BBd4xiL5__"